import { useLingui } from '@lingui/react/macro';

import FileUpload from '@/components/FileUpload';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { Medium } from '@/models/medium';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

import { PaymentOrRefundStepConfig } from './ExternalPaymentOrRefundModal';

export const ProofOfPaymentInput = ({
  proofOfPaymentMedia,
  stepConfig,
  hasRefashionActions,
  showErrors,
  step,
}: {
  proofOfPaymentMedia: Medium[];
  stepConfig: PaymentOrRefundStepConfig;
  hasRefashionActions: boolean;
  showErrors: boolean;
  step: 'payment' | 'refund';
}) => {
  const { t } = useLingui();
  const { request } = useRequestContext();

  if (!stepConfig.fields?.receipt?.enabled) {
    return null;
  }

  const isRequired =
    stepConfig.fields?.receipt?.required && (step === 'payment' ? hasRefashionActions : true);

  const isInvalid = isProofOfPaymentInvalid({
    proofOfPaymentMedia,
    stepConfig,
    hasRefashionActions,
    step,
  });

  const label =
    step === 'payment'
      ? t({
          id: 'request.step-actions.payment-or-refund.proof-of-payment.label',
          message: 'Proof of payment',
        })
      : t({
          id: 'request.step-actions.payment-or-refund.proof-of-refund.label',
          message: 'Proof of refund',
        });

  return (
    <FileUpload
      label={
        <>
          {label}
          {!isRequired && <OptionalLabel />}
        </>
      }
      media={proofOfPaymentMedia}
      uploadData={{
        type: 'proof-of-external-payment',
        requestId: request.id,
      }}
      deleteWithApi
      withQrCode
      secondaryActionIconOnly
      error={
        showErrors && isInvalid
          ? step === 'payment'
            ? t({
                id: 'confirm-client-payment-or-refund-modal.errors.missing-proof-of-payment',
                message: 'Please add a proof of payment',
              })
            : t({
                id: 'confirm-client-payment-or-refund-modal.errors.missing-proof-of-refund',
                message: 'Please add a proof of refund',
              })
          : undefined
      }
    />
  );
};

export const isProofOfPaymentInvalid = ({
  proofOfPaymentMedia,
  stepConfig,
  hasRefashionActions,
  step,
}: {
  proofOfPaymentMedia: Medium[];
  stepConfig: PaymentOrRefundStepConfig;
  hasRefashionActions: boolean;
  step: 'payment' | 'refund';
}) => {
  if (!stepConfig.fields?.receipt?.enabled) {
    return false;
  }

  const isRequired =
    stepConfig.fields?.receipt?.required && (step === 'payment' ? hasRefashionActions : true);

  if (isRequired && !proofOfPaymentMedia?.length) {
    return true;
  }

  return false;
};
